// extracted by extract-css-chunks-webpack-plugin
module.exports = {"input":"amount-input__input___3F4aW"};
    if(module.hot) {
      // 1652416432121
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  